export default {
      id: "logo-cb-color-large-usage",
      viewBox: "0 0 47 30",
      url: "/assets/svg/" + "sprite.svg#logo-cb-color-large-usage",
      toString: function () {
        return this.url;
      }
    }